export const environment = {
    enableBugsnag : false,
    production: false,
    apiUrl: 'https://staging-yokahu-frontend.yokahu.co/api',
    baseUrl : 'https://staging-yokahu-frontend.yokahu.co',
    brokerApiUrl :'https://staging.cat-risk.com',
    captcha_siteKey: '6LfZW_srAAAAACWG6dJsgos-954mPZokNfJu_aX9',
    Stripe_Publishable_Key: 'pk_test_51HUXLnJiyZvNDOChgKwYNPcdXeSLChlNZgqoMiDsT9RXR6QKxOYqb76AKDttgGjayPJnOg2M6pQg2r7GU6E76Yk100ObCfl1wO',
    sessionUserTimeOut: 30,
    zoomForCountry : {
    'Jamaica': 8,
    'The Bahamas': 8,
    'US Virgin Islands': 8,
    'Saint Lucia': 11 
    },
    productListForCountry : {
    'Jamaica': 'year',
    'The Bahamas': 'year',
    'US Virgin Islands': 'year',
    'Saint Lucia': 'year'
    },
    gmap_key:'AIzaSyDftDM4EXczuSZlq7mc5vwl_VYhLWgazwc'
};
